import { Center } from "@mantine/core";
import { Navigate, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { AxioLoader } from "./AxioLoader";
import { useAuth } from "../context/useAuth";
import { companyApi } from "../lib/api";
import type { CompanyType } from "../types/api";

interface CompanyTypeRouteProps {
  allowedType: CompanyType;
}

export function CompanyTypeRoute({ allowedType }: CompanyTypeRouteProps) {
  const { user, loading } = useAuth();
  const membershipQuery = useQuery({
    queryKey: ["my-company"],
    queryFn: companyApi.myCompany,
    enabled: !!user && user.role === "company_user",
  });

  if (loading || membershipQuery.isLoading) {
    return (
      <Center h="100vh">
        <AxioLoader size="lg" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const companyType = membershipQuery.data?.company_type ?? "client";
  if (companyType !== allowedType) {
    return <Navigate to={companyType === "consultancy" ? "/consultancy" : "/hr"} replace />;
  }

  return <Outlet />;
}
